import * as yup from 'yup';

const onlyLettersRegex = /^[A-Za-zğüşöçıİĞÜŞÖÇ\s]+$/;

export const schema = yup.object().shape({
	bank: yup.string().required('Banka adı zorunludur'),
	firstName: yup.string().required('Ad zorunludur').min(2, 'Ad en az 2 karakter olmalıdır').max(30, 'Ad en fazla 30 karakter olabilir').matches(onlyLettersRegex, 'Ad sadece harflerden oluşmalıdır'),
	lastName: yup
		.string()
		.required('Soyad zorunludur')
		.min(2, 'Soyad en az 2 karakter olmalıdır')
		.max(30, 'Soyad en fazla 30 karakter olabilir')
		.matches(onlyLettersRegex, 'Soyad sadece harflerden oluşmalıdır'),
	identityNumber: yup
		.string()
		.required('TC Kimlik numarası zorunludur')
		.matches(/^[0-9]+$/, 'TC Kimlik numarası sadece rakamlardan oluşmalıdır')
		.length(11, 'TC Kimlik numarası 11 haneli olmalıdır'),
	iban: yup
		.string()
		.required('IBAN zorunludur')
		.matches(/^[0-9]+$/, 'IBAN sadece rakamlardan oluşmalıdır')
});
